// extracted by mini-css-extract-plugin
export default {"wrapper":"fC-z","viewport":"gC-z","container":"hC-z","slide":"iC-z"};